/* eslint-disable import/prefer-default-export */
import styled from 'react-emotion';
import AUIMenu from '@ublend-npm/aulaui-next-web/Menu';
import BaseIconButton from '@ublend-npm/aulaui-next-web/IconButton';
import { colors } from '@ublend-npm/aulaui-next-web/themes/default';

export const IconButton = styled(BaseIconButton)`
  color: ${colors.blackAlpha(0.6)};
  background: transparent;
  color: ${colors.blackAlpha(0.6)};
  background-color: ${colors.white};
  cursor: pointer;
  width: 32px;
  height: 32px;
`;

export const Menu = styled(AUIMenu)`
  display: inline-block;
  margin-left: 16px;
`;
